import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

//  列表接口
export const getAntManageList = (params: any) =>
  request({
    url: '/manage/ant',
    method: 'get',
    params
  })

//  接口详情
export const getAntManageInfo = (params: any) =>
  request({
    url: '/manage/ant/' + params.id,
    method: 'get',
    params
  })

//  创建
export const postAntManageList = (data: any) =>
  request({
    url: '/manage/ant',
    method: 'post',
    data
  })

//  编辑
export const patchAntManageInfo = (data: any) =>
  request({
    url: '/manage/ant/' + data.id,
    method: 'patch',
    data
  })

// 删除
export const delAntManageList = (data: any) =>
  request({
    url: `/manage/ant/${data.id}`,
    method: 'delete'
  })

// 交易明细列表接口
export const transactionInfo = (params: any) =>
  request({
    url: `manage/ant/${params.name}/transaction`,
    method: 'get',
    params: params.body
  })

// 好友列表
export const invitationList = (params: any) =>
  request({
    url: `manage/ant/${params.id}/invitation`,
    method: 'get',
    params: params.body
  })

// 调整余额接口
export const getChangeBalance = (data: any) =>
  request({
    url: `manage/ant/${data.name}/change-balance`,
    method: 'put',
    data: data.body
  })

// 分配额度接口
export const getAssignBalance = (data: any) =>
  request({
    url: `manage/ant/assign-balance`,
    method: 'post',
    data
  })

// 蚂蚁统计接口
export const getAntStatistics = (params: any) =>
  request({
    url: `manage/ant/statistics`,
    method: 'get',
    params
  })

// 导出接口
export const getAntExport = (data: any) =>
  request({
    url: `manage/ant/export` + objToUrlParams(data),
    method: 'post'
  })

// 好友导出
export const getFriendExport = (data: any) =>
  request({
    url: `manage/ant/${data.id}/invitation/export` + objToUrlParams(data),
    method: 'post'
  })

// 销售接口
export const getSaleAction = (data: any) =>
  request({
    url: `manage/ant/action`,
    method: 'post',
    data
  })

// 发送蚂蚁系统系统通知（系统设置）
export const getSystemNotice = (data: any) =>
  request({
    url: `manage/ant-system-notice`,
    method: 'post',
    data
  })

// 发送蚂蚁系统系统通知
export const getSystemNoticeList = (params: any) =>
  request({
    url: `manage/ant-system-notice`,
    method: 'get',
    params
  })

// 批量解冻
export const setUnfreeze = (data: any) =>
  request({
    url: `manage/unfreeze-ant-balance`,
    method: 'post',
    data
  })

// 批量冻结
export const setFreeze = (data: any) =>
  request({
    url: `manage/freeze-ant-balance`,
    method: 'post',
    data
  })
